/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { aggregatorsDoordashSignupUrlPost } from '../fn/doordash/aggregators-doordash-signup-url-post';
import { AggregatorsDoordashSignupUrlPost$Params } from '../fn/doordash/aggregators-doordash-signup-url-post';
import { aggregatorsDoordashStoresGet } from '../fn/doordash/aggregators-doordash-stores-get';
import { AggregatorsDoordashStoresGet$Params } from '../fn/doordash/aggregators-doordash-stores-get';
import { DoordashOnboardingValidationResponse } from '../models/doordash-onboarding-validation-response';
import { doordashStoresStoreIdOnboardingValidationGet } from '../fn/doordash/doordash-stores-store-id-onboarding-validation-get';
import { DoordashStoresStoreIdOnboardingValidationGet$Params } from '../fn/doordash/doordash-stores-store-id-onboarding-validation-get';
import { SignupUrlResponse } from '../models/signup-url-response';
import { StoresGetResponse } from '../models/stores-get-response';

@Injectable({ providedIn: 'root' })
export class DoordashService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `doordashStoresStoreIdOnboardingValidationGet()` */
  static readonly DoordashStoresStoreIdOnboardingValidationGetPath = '/doordash/stores/{storeId}/onboarding/validation';

  /**
   * check Doordash onboarding status of a store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doordashStoresStoreIdOnboardingValidationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  doordashStoresStoreIdOnboardingValidationGet$Response(params: DoordashStoresStoreIdOnboardingValidationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DoordashOnboardingValidationResponse>> {
    return doordashStoresStoreIdOnboardingValidationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * check Doordash onboarding status of a store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doordashStoresStoreIdOnboardingValidationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doordashStoresStoreIdOnboardingValidationGet(params: DoordashStoresStoreIdOnboardingValidationGet$Params, context?: HttpContext): Observable<DoordashOnboardingValidationResponse> {
    return this.doordashStoresStoreIdOnboardingValidationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<DoordashOnboardingValidationResponse>): DoordashOnboardingValidationResponse => r.body)
    );
  }

  /** Path part for operation `aggregatorsDoordashStoresGet()` */
  static readonly AggregatorsDoordashStoresGetPath = '/aggregators/doordash/stores';

  /**
   * fetch store_candidates from doordash.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsDoordashStoresGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsDoordashStoresGet$Response(params: AggregatorsDoordashStoresGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoresGetResponse>> {
    return aggregatorsDoordashStoresGet(this.http, this.rootUrl, params, context);
  }

  /**
   * fetch store_candidates from doordash.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsDoordashStoresGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsDoordashStoresGet(params: AggregatorsDoordashStoresGet$Params, context?: HttpContext): Observable<StoresGetResponse> {
    return this.aggregatorsDoordashStoresGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoresGetResponse>): StoresGetResponse => r.body)
    );
  }

  /** Path part for operation `aggregatorsDoordashSignupUrlPost()` */
  static readonly AggregatorsDoordashSignupUrlPostPath = '/aggregators/doordash/signup-url';

  /**
   * Net New Merchant API.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsDoordashSignupUrlPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsDoordashSignupUrlPost$Response(params: AggregatorsDoordashSignupUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SignupUrlResponse>> {
    return aggregatorsDoordashSignupUrlPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Net New Merchant API.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsDoordashSignupUrlPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsDoordashSignupUrlPost(params: AggregatorsDoordashSignupUrlPost$Params, context?: HttpContext): Observable<SignupUrlResponse> {
    return this.aggregatorsDoordashSignupUrlPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SignupUrlResponse>): SignupUrlResponse => r.body)
    );
  }

}
